export const getShopShortName = (name) => {
    if (!name) return ''

    const words = name.split(' ')
    const firstLetter = words[0]?.charAt(0).toUpperCase() || ''
    const secondLetter = words[1]?.charAt(0).toUpperCase() || ''

    return firstLetter + secondLetter
}
